import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../../Components/Preloader";
import { getCameraListById, playCameraData } from "../../redux/actions/CameraActions";
import CPPlusLive from "../../Components/CPPlusLive";

const PlayVideo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, errors },
    cameraReducer: {
      loadingCamera,
      errorsCamera,
      cameraLists,
      changedCameraStatus,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (id && auth?.accessToken) {
      dispatch(playCameraData(auth?.accessToken, id));
    }
  }, [auth?.accessToken, id, dispatch]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsCamera && Object.keys(errorsCamera).length > 0) {
      if (errorsCamera?.status === 401) {
        dispatch(logout());
        toast.error(errorsCamera?.data?.message);
        navigate('/login');
      } else if (errorsCamera?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsCamera?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      } else if (errorsCamera?.status === 400) {
        // Handle other status
        dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      } else {
        dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      }
    }
  }, [errorsCamera, dispatch, navigate]);

  useEffect(() => {
    if (changedCameraStatus?.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCameraStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      navigate(-1);
    }
  }, [changedCameraStatus, dispatch, navigate]);

  useEffect(() => {
    dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
  }, [dispatch]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Camera"), path: "/Camera" },
          { label: t("Play Video"), path: `/Play-Video/${id}`, active: true },
        ]}
        title={t("CP Plus Live Video")}
      />

      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              {errorsCamera?.data?.message && (
                <div className="alert alert-danger">
                  {errorsCamera?.data?.message}
                </div>
              )}

              <CPPlusLive cameraData={cameraLists} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingCamera && (<Preloader />)}
    </>
  );
};

export default PlayVideo;
